"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FontSizeDestination = void 0;
var tslib_1 = require("tslib");
var character_property_descriptor_1 = require("../../../../../core/model/character/character-property-descriptor");
var character_formatting_leaf_element_destination_1 = require("../character-formatting-leaf-element-destination");
var FontSizeDestination = (function (_super) {
    tslib_1.__extends(FontSizeDestination, _super);
    function FontSizeDestination() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    FontSizeDestination.prototype.processElementOpen = function (reader) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var value;
            return tslib_1.__generator(this, function (_a) {
                value = this.data.readerHelper.getWpSTIntegerValue(reader, 'val', -1);
                if (value > 0)
                    this.setProperty(Math.max(1, value / 2));
                return [2];
            });
        });
    };
    FontSizeDestination.prototype.getDescriptor = function () {
        return character_property_descriptor_1.CharacterPropertyDescriptor.size;
    };
    return FontSizeDestination;
}(character_formatting_leaf_element_destination_1.CharacterFormattingLeafElementDestination));
exports.FontSizeDestination = FontSizeDestination;
